import { Alert } from "react-bootstrap"
import { useDispatch } from "react-redux"
import { useSelector } from "react-redux"
import { useEffect, useState } from "react"
import { setAlertMsgStore } from "../../features/alertMsgSlisce"

export const AlertMsg = () => {
    // const alertMsg = useSelector((state: any) => state.alertMsg) as IAlertMsg
    const alertMsg = useSelector((state) => state.alertMsg)
    const [virtualVib, setVirtualVib] = useState(false)
    const dispatch = useDispatch()
    const startVibro = (timer) => {
        if ('vibrate' in navigator && typeof navigator.vibrate === 'function') {
            navigator.vibrate(timer);
        }
    }

    useEffect(() => {
        if (alertMsg !== null) {
            if (alertMsg?.variant === "warnig") {
                startVibro([35, 35, 35]);
            }
            if (alertMsg?.variant === "danger") {
                if ('vibrate' in navigator && typeof navigator.vibrate === 'function') {
                    setVirtualVib(true)
                    startVibro([75, 50, 50, 50, 50]);
                }
            }
            const delayvvrtualVib = setTimeout(() => {
                setVirtualVib(false)
            }, 500)
            const delayDebounceFnMsg = setTimeout(() => {
                dispatch(setAlertMsgStore(null))
            }, 3000)
            clearTimeout(delayvvrtualVib)
            return () => clearTimeout(delayDebounceFnMsg)
        }
    }, [alertMsg])

    return (
        // <Alert show={(alertMsg !== null)} variant={alertMsg?.variant} dismissible>
        <Alert show={(alertMsg !== null)} className={`position-fixed shadow-lg ms-2 me-2`}
        // <Alert show={true} className={`position-fixed shadow-lg ms-2 me-2`}
            // <Alert show={true} className="position-fixed shadow-lg ms-2 me-2 shake-element"
            style={{ top: "0.5rem", right: 0, left: 0, zIndex: 2005 }}
            variant={alertMsg?.variant} dismissible>
            {alertMsg?.content ?
                <Alert.Heading>{alertMsg?.title}</Alert.Heading> :
                <>
                    {alertMsg?.title}
                </>
            }
            {alertMsg?.content}
        </Alert>
    )

}
